/* src/app/components/terminals/terminal-list/terminal-list.component.scss */
td.mat-mdc-cell,
th.mat-mdc-header-cell {
  border-bottom-width: 0px !important;
}
.no-display {
  display: none;
}
tr.mat-mdc-row {
  height: 48px !important;
}
th.mat-mdc-header-cell {
  font-weight: bold;
  border-bottom: 1px solid #dee2e6 !important;
  padding-bottom: 4px !important;
  padding-top: 4px !important;
}
thead th,
th th {
  padding-bottom: 4px !important;
}
thead,
th {
  height: fit-content !important;
}
thead *,
th * {
  height: fit-content !important;
}
.inputField {
  padding: 10px;
}
/*# sourceMappingURL=terminal-list.component-NRTT5MV2.css.map */
